import useApi from '~/composables/useApi';
import queryString from './queryString.gql';

const useGetCategoryUrl = () => {
  const { query } = useApi();
  const getData = async (uids) => {
    return query(queryString, {
      uids: uids
    })
      .then((data) => {
        let parsed = data.data
        return parsed;
      })
      .catch((e) => {
        return e
      });
  }
  return {
    getData
  }
}

export default useGetCategoryUrl